import FileDownloadIcon from '@rsuite/icons/FileDownload';
import * as Sentry from '@sentry/browser';
import React, { useCallback } from 'react';
import { IconButton } from 'rsuite';
// @ts-ignore strOracleApiSender is not typed
import { strOracleApiSender } from '@/utils/stroracle-api-sender';
// @ts-ignore RsuiteTooltipWrapper is not typed
import { RsuiteTooltipWrapper } from '@/widgets/components/tooltips';
import styled from 'styled-components';
import { TComplaintData } from './types';
import { ComplaintFileDownloadError } from './errors';
// @ts-ignore toaster is not typed
import { toaster } from '@/utils/toaster';

const Files = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Button = styled(IconButton)`
  width: 300px;
`;

const Text = styled.p`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

type TComplaintFilesProps = {
  files: TComplaintData['files'];
};

export function ComplaintFiles(props: TComplaintFilesProps) {
  const { files = [] } = props;

  const requestFileById = useCallback(async (id, fileName) => {
    try {
      const { data } = await strOracleApiSender.get(`/complaintFileUrl/${id}`);

      if (!data.url) throw new Error(`No URL for file ${id} - ${fileName}`);

      const link = document.createElement('a');
      link.href = data.url;
      link.download = fileName;
      link.click();
      link.remove();
    } catch (err) {
      Sentry.captureException(new ComplaintFileDownloadError(err)),
        { contexts: { id, fileName } };
      toaster.error(
        'Failed to retrieve the file. An error report has been sent to our development team. Please try again at a later time.'
      );
    }
  }, []);

  if (!files.length) return null;

  return (
    <Files>
      {files.map(({ fileName, id }) => (
        <Button
          key={id}
          icon={<FileDownloadIcon />}
          onClick={() => requestFileById(id, fileName)}
        >
          <RsuiteTooltipWrapper tooltipPosition="right" text={fileName}>
            <Text>Download {fileName}</Text>
          </RsuiteTooltipWrapper>
        </Button>
      ))}
    </Files>
  );
}
